import { render, staticRenderFns } from "./ListWallpaperSelect.vue?vue&type=template&id=21fb95d6&scoped=true&"
import script from "./ListWallpaperSelect.vue?vue&type=script&lang=js&"
export * from "./ListWallpaperSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb95d6",
  null
  
)

export default component.exports